module.exports = __webpack_public_path__ + "media/WR Blob 5.224aa99d.mp3";